<template>
    <div class="infoslegales_container">
        <div v-if=entreprise.acf.effectif>
          <dt>Effectif :</dt>
          <dd>{{ entreprise.acf.effectif }}</dd>
        </div>
        <div v-if=entreprise.acf.code_ape>
          <dt>Code APE :</dt>
          <dd>{{ entreprise.acf.code_ape }}</dd>
        </div>
        <div>
          <dt>N° Siret :</dt>
          <dd>{{ entreprise.acf.entreprise_siret }}</dd>
        </div>
        <div v-if=entreprise.acf.date_creation>
          <dt>Date de création :</dt>
          <dd>{{ entreprise.acf.date_creation }}</dd>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        entreprise: Object,
    },
};
</script>

<style lang="scss" scoped>
div.infoslegales_container {
  div {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
    dt {
      margin: 0;
      padding: 0 5px 0 0;
      display: inline-block;
      color: var(--black);
      font-size: 14px;
      font-weight: 700;
    }
    dd {
      margin: 0;
      padding: 0;
      display: inline-block;
      color: var(--black);
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>